<template>
  <section class="winners-wrapper" id="winners">
    <div class="content-w">
      <div class="content">
        <div class="page-title">
          <img src="@/assets/svg/winners-title.svg" alt="Победители" />
        </div>

        <div class="d-flex align-items-start title">
          <div class="w-100">
            <div class="search-bar">
              <b-form-input
                id="search-bar"
                type="search"
                class="search"
                v-model="searchPhone"
                invalid-feedback="Некорректный email"
                placeholder="Поиск по email"
                v-debounce:400ms="searchWinner"
              >
              </b-form-input>

              <img
                src="@/assets/svg/search-icon.svg"
                class="search-img"
                loading="lazy"
              />

              <b-button
                class="mobile-none button button-gold"
                variant="primary"
                @click="searchWinner"
              >
                Найти
              </b-button>
            </div>
          </div>
        </div>

        <div class="plug" v-if="!data">ПОБЕДИТЕЛИ ЕЩЕ НЕ ОПРЕДЕЛЕНЫ</div>

        <div class="mt-4" v-if="data">
          <div class="table-wrapper"> 
            <div class="table-header">
              <div>Дата розыгрыша</div>

              <div>Имя участника</div>

              <div>Email</div>

              <div>Наименование приза</div>
            </div>

            <!-- <div class="table-header mobile">
              <div>
                Дата розыгрыша / <br />
                Имя / <br />
                Email
              </div>

              <div>Приз</div>
            </div> -->

            <div class="table">
              <div class="table-row" v-for="winner in winners">
                <div>{{ winner.period }}</div>

                <div>{{ winner.name }}</div>

                <div>{{ winner.email }}</div>

                <div>{{ winner.prize }}</div>
              </div>
            </div>

            <!-- <div class="table mobile-block">
              <div class="table-row" v-for="winner in winners">
                <div>
                  {{ winner.period }} <br />
                  {{ winner.name }} <br />
                  {{ winner.email }}
                </div>

                <div>{{ winner.prize }}</div>
              </div>
            </div> -->
          </div>

          <Pagination :pages="pagination" @page-change="pageChange" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Pagination from "@/components/Pagination.vue";

export default {
  name: "WinnersSection",

  components: {
    Pagination,
  },

  data: () => ({
    data: false,
    tooltipCoupon: false,
    tooltipCinema: false,
    winners: [],
    pagination: [],
    searchPhone: "",
    noResults: false,
  }),

  methods: {
    getWinners(pagination) {
      if (pagination) {
        this.$http
          .get("/reference/winners?per_page=15&page=" + pagination + "")
          .then((response) => {
            if (!this.pagination.length) {
              for (let i = 0; i < response.data.meta.lastPage; i++) {
                this.pagination.push(i + 1);
              }
            }
            this.winners = response.data.data;

            if (this.winners.length) {
              this.noResults = false;
            }
          });
      } else {
        this.$http.get("/reference/winners?per_page=15").then((response) => {
          if (!this.pagination.length) {
            for (let i = 0; i < response.data.meta.lastPage; i++) {
              this.pagination.push(i + 1);
            }
          }
          this.winners = response.data.data;

          if (this.winners.length) {
            this.data = true;
            this.noResults = false;
          }
        });
      }
    },

    searchWinner() {
      this.$http
        .get(
          "/reference/winners?per_page=15&search=" +
            this.searchPhone
              .split("+")
              .join("")
              .split(" ")
              .join("")
              .split("(")
              .join("")
              .split(")")
              .join("")
              .split("+")
              .join("-") +
            "",
        )
        .then((response) => {
          this.winners = response.data.data;

          if (this.winners.length < 1) {
            this.noResults = true;
          }
        })
        .catch(() => {
          this.winners = [];
        });
    },

    pageChange(pageNumber) {
      this.getWinners(pageNumber);
    },
  },

  mounted() {
    this.getWinners()
  },
};
</script>

<style scoped lang="scss">
.winners-wrapper {
  z-index: 99;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 127px;

  @media (max-width: 999px) {
    padding-bottom: 52px;
  }

  @media (max-width: 576px) {
    padding-bottom: 60px;
  }
}

.search-img {
  position: absolute;
  left: 15px;
  top: 50%;
  bottom: 50%;
  transform: translateY(-50%);
}

.content-wrapper {
  padding: 0 20px;
  display: flex;
  justify-content: center;

  @media (max-width: 999px) {
    padding: 0px;
  }

  .content-w {
    display: flex;
    justify-content: center;
  }

  .content {
    max-width: 1123px;
    background-color: #f5f5f5;
    border-radius: 25px;
    border: 2px solid #e7e7e7;
    width: 100%;
    padding: 30px 80px;

    @media (max-width: 999px) {
      border-radius: 0;
    }

    @media (max-width: 576px) {
      padding: 15px 25px;
      padding-top: 0;
    }
  }
}

.button {
  margin-left: 22px;
  min-width: 270px;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 1200px) {
    min-width: 250px;
  }

  @media (max-width: 999px) {
    margin-left: 11px;
    min-width: 207px;
  }
}

.search {
  border-radius: 25px;
  height: 56px;
  padding-left: 50px;

  &:active,
  &:focus {
    box-shadow: none !important;
    outline: none !important;
    border: 1px solid $green !important;
  }

  @media (max-width: 999px) {
    height: 39px;
  }
}

.search-bar {
  display: flex;
  align-items: center;
  position: relative;

  @media (max-width: 576px) {
    flex-direction: column;
    margin-bottom: 0;
  }
}

.page-title {
  z-index: 99;
  position: relative;
  
  img {
    width: 314px;
    margin-bottom: 30px;
    z-index: 99;
    position: relative;

    @media (max-width: 1200px) {
      width: 240px;
      margin-bottom: 30px;
    }

    @media (max-width: 999px) {
      width: 182px;
      margin-bottom: 30px;
    }

    @media (max-width: 750px) {
      width: 149px;
      margin-bottom: 30px;
    }
  }
}

.plug {
  font-weight: 700;
  font-family: $regular;
  text-align: center;
  margin-top: 30px;
  font-size: 30px;
  color: white;

  @media (max-width: 768px) {
    font-size: 18px;
  }
}

.table-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 700;
  padding: 0 20px;
  border-radius: 50px;
  height: 55px;
  background: linear-gradient(90deg, #BD7A30 0%, #F2BC81 100%);

  @media (max-width: 999px) {
    font-size: 14px;
    align-items: center;
  }

  @media(max-width: 576px) {
    font-size: 12px;
    line-height: 110%;
    padding: 0 6px;
  }

  @media(max-width: 330px) {
    font-size: 11px;
  }

  // @media(max-width: 576px) {
  //   height: 75px;
  // }

  div {
    width: 25%;
    text-align: center;

    @media (max-width: 999px) {
      width: 50%;
    }

    @media(max-width: 576px) {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }
}

.table-wrapper {
  background-color: white;
  border-radius: 30px;

  @media (max-width: 576px) {
    border-radius: 50px;
  }
}

.table {
  background-color: $white;
  border-radius: 25px;
  // padding: 0 20px;
  width: 100%;
  box-shadow: 0px 7px 20px 7px rgba(103, 103, 103, 0.1);
}

.table-row {
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
  font-size: 18px;
  border-bottom: 1px solid #e7e7e7;
  border-radius: 50px;
  padding: 0 12px;

  @media (max-width: 1200px) {
    font-size: 14px;
  }

  @media (max-width: 999px) {
    font-size: 16px;
  }

  @media(max-width: 768px) {
    font-size: 12px;
    line-height: 110%;
    padding: 0 6px;
    overflow-wrap: break-word;
    word-break: break-all;
  }

  @media(max-width: 330px) {
    font-size: 11px;
  }

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(2n) {
    background-color: #F2F2F2;
  }

  div {
    text-align: center;
    width: 25%;

    // @media (max-width: 999px) {
    //   width: 50%;
    // }

    @media(max-width: 678px) {
      white-space: normal;
    }
  }
}

.desktop {
  @media (max-width: 999px) {
    display: none;
  }
}

.mobile {
  display: none;

  @media (max-width: 999px) {
    display: flex;
  }
}

.mobile-block {
  display: none;

  @media (max-width: 999px) {
    display: block;
  }
}

.mobile-none {
  @media (max-width: 576px) {
    display: none;
  }
}
</style>
